import ko from '@tko/build.knockout';
import templateMarkup from 'raw-loader!./endpointactivecalls-widget.html';

        function EndpointActiveCalls(params) {

            var self = this;
            this.observableOptions = params.observableOptions;
            this.observableData = params.observableData;
            self.panelTemplate = params.panelTemplate;
            self.widgetSignals = params.widgetSignals;
            self.viewLevelOptions = params.viewLevelOptions;
            self.visible = ko.observable(false);
           // if (self.widgetSignals)
            //     self.widgetSignals().dataLoaded.dispatch();

            self.endpointId = (params.viewLevelOptions &&
                    params.viewLevelOptions() &&
                    params.viewLevelOptions().endpointId)
                ? params.viewLevelOptions().endpointId
                : null;
            if (self.endpointId) {
                var options = self.observableOptions();
                options.endpointId = self.endpointId;
                self.observableOptions(options);
            }

            self.id = ko.observable();
            self.historicalId = ko.observable();
            self.name = ko.observable();
            self.altName = ko.observable();

            self.updateVLOTitleAndHistId = function () {
                var vlo = self.viewLevelOptions();

                var altName = self.altName();

                var title = altName ? altName : self.name();

                if ((vlo.title !== title) || (vlo.historicalId !== self.historicalId())) {
                    vlo.title = title;
                    vlo.historicalId = self.historicalId();
                    self.viewLevelOptions(vlo);
                }

            };

            self.RefreshData();
            self.subscriptions = [];
            self.subscriptions.push(self.observableData.subscribe(function () { self.DataUpdated(); }));


        }

        EndpointActiveCalls.prototype.RefreshData = function () {
            var self = this;

            var data = self.observableData();

            if (!$.isEmptyObject(data)) {

                self.id(data.id);
                self.historicalId(data.historicalId);
                self.name(data.name);
                self.altName(data.altName);

                self.updateVLOTitleAndHistId();

                self.visible(data.maxCount > 0);

                if (self.visible()) {
                    $(".EndpointInfoActiveCalls").show();
                } else {
                    $(".EndpointInfoActiveCalls").hide();
                }
            }
        };

        EndpointActiveCalls.prototype.DataUpdated = function () {
            var self = this;
            self.RefreshData();
        };

        EndpointActiveCalls.prototype.dispose = function () {
        };

        export default { viewModel: EndpointActiveCalls, template: templateMarkup };

    
